import {z} from 'zod';

import {FinancialProductMoneySchema} from './FinancialProductMoneySchema';
import {LeasingTargetGroupSchema} from './LeasingTargetGroupSchema';

export const FinancialProductCalculationSchema = z.object({
  termMonths: z.number(),
  monthlyPayment: FinancialProductMoneySchema,
  downPaymentPercentage: z.number().nullable(),
  downPaymentAmount: FinancialProductMoneySchema.nullable(),
  netCredit: FinancialProductMoneySchema.nullable(),
  grossCredit: FinancialProductMoneySchema.nullable(),
  totalInterest: FinancialProductMoneySchema.nullable(),
  totalPayable: FinancialProductMoneySchema.nullable(),
  nominalRate: z.string().nullable(),
  apr: z.string().nullable(),
  balloonPaymentPercentage: z.number().nullable(),
  balloonPaymentAmount: FinancialProductMoneySchema.nullable(),
  leasingTargetGroup: LeasingTargetGroupSchema.nullable(),
  annualMileage: z.number().nullable(),
  leasingDownPayment: FinancialProductMoneySchema.nullable(),
  monthlyPaymentMode: z.enum(['GROSS', 'NET']).nullable(),
});
export type FinancialProductCalculation = z.infer<typeof FinancialProductCalculationSchema>;
